module.exports = __webpack_public_path__ + "img/setcemg.3f68c0b3.png";